import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import StripoTemplateType from '@/data/models/domain/stripo/StripoTemplateType'

@OrmModel(modelNames.STRIPO_TEMPLATE_SEASON)
export default class StripoTemplateSeason extends StripoTemplateType {}
